import lightImg from 'assets/img/spot-illustrations/1.png';
import darkImg from 'assets/img/spot-illustrations/dark_1.png';
import { useNavigate } from 'react-router-dom';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from 'providers/AuthProvider';
import { useTranslation } from 'react-i18next';

const SignOutForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const tt = (key: string, options?: Record<string, unknown>) =>
    t(key, { ns: 'translation', ...options });

  const handleSignOut = () => {
    logout();
    navigate(`/auth/login`, { replace: true });
  };

  return (
    <div className="text-center mb-6 mx-auto">
      <img className="mb-7 d-dark-none" src={lightImg} alt="phoenix" />
      <img className="mb-7 d-light-none" src={darkImg} alt="phoenix" />
      <div className="mb-6">
        <h4 className="text-body-highlight">{tt('pages.auth.signOut.thankYou')}</h4>
        <p className="text-body-tertiary"></p>
        <p className="text-body-tertiary">
          {tt('pages.auth.signOut.loggedOutSuccess')}
        </p>
        <p className="text-body-tertiary"></p>
        <h4 className="text-body-highlight">{tt('pages.auth.signOut.comeBackSoon')}</h4>
      </div>
      <div className="d-grid">
        <Button
          variant="primary"
          onClick={handleSignOut}
          startIcon={<FontAwesomeIcon icon={faAngleLeft} className="me-2" />}
        >
          {tt('pages.auth.signOut.backToLogin')}
        </Button>
      </div>
    </div>
  );
};

export default SignOutForm;
